import CategoryList from "../components/CategoryList";
import { Box, Typography, Button } from "@mui/material";

const Home = () => {
  return (
    <Box>
      <CategoryList />
      
    </Box>
  );
};

export default Home;
